import src from "IMAGE";
export default { src, width: 190, height: 32, blurWidth: 0, blurHeight: 0};
